<template>
  <b-row class="mr-0">
    <b-modal id="modal-punish" size="lg" centered :title="$store.state.modal.kirimAppreciation" v-model="localVisible" @hidden="$emit('close')">
      <b-form>
        <!-- 4. File Upload -->
        <b-form-group :label="$store.state.form.file" label-cols-md="3">
          <b-form-file v-model="data.file" :state="checkIfValid('file')" browse-text="Pilih File" placeholder="Pilih atau seret file ke sini..."></b-form-file>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" class="text-dark mr-2" @click="closeModal">
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="success" class="text-white" @click="send"> {{ $store.state.form.kirim }} </b-button>
      </template>
    </b-modal>
  </b-row>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
  name: "ModalReward",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dataReward: {
      type: Object,
    },
  },
  data() {
    return {
      data: {
        judul: "",
        target: "user",
        masterUserId: [],
        masterDivisiId: [],
        masterPosisiId: [],
        file: null,
        broadcastDate: null,
        tipe: "appreciation",
        isi: null,
        all: false,
      },
      busy: false,
      button: "Simpan",
      targetOptions: [
        { value: "all", text: "All" },
        { value: "user", text: "User" },
        { value: "division", text: "Division" },
        { value: "position", text: "Position" },
      ],
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    isValid() {
      return !this.$v.data.$invalid;
    },
    localVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  mixins: [validationMixin],
  validations() {
    return {
      data: {
        file: { required },
        // broadcastDate: { required },
      },
    };
  },
  methods: {
    closeModal() {
      this.localVisible = false;
      this.$emit("close");
    },
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) return null;
      return !field.$invalid;
    },
    send() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$bvToast.toast("Silakan lengkapi data terlebih dahulu", {
          title: "Validasi",
          variant: "danger",
          solid: true,
        });
        return;
      }
      this.busy = true;
      this.button = this.$store.state.form.tunggu;
      const formData = new FormData();
      formData.append("masterUserId", [this.dataReward.id]);
      formData.append("all", this.data.all);
      formData.append("file1", this.data.file);
      formData.append("tipe", this.data.tipe);
      formData.append("judul", "Appreciation Letter");
      // formData.append("broadcastDate", this.data.broadcastDate);
      this.$axios
        .post("announcement/register", formData)
        .then((res) => {
          this.$emit("alertFromChild", {
            variant: res.data.message === "sukses" ? "success" : "danger",
            msg: res.data.message === "sukses" ? "BERHASIL MENDAFTARKAN ANNNOUNCEMENT" : res.data.message.toUpperCase(),
            showing: true,
          });
          this.resetForm();
          this.closeModal();
        })
        .catch((err) => {
          this.$emit("alertFromChild", {
            variant: "danger",
            msg: err.message.toUpperCase(),
            showing: true,
          });
        })
        .finally(() => {
          this.busy = false;
          this.button = this.$store.state.form.simpan;
        });
    },
    resetForm() {
      this.data = {
        judul: "",
        target: "",
        user: "",
        file: null,
        broadcastDate: null,
        tipe: "announcement",
        all: false,
      };
      this.$v.$reset();
    },
  },
  watch: {
    lang() {
      this.button = this.$store.state.form.simpan;
    },
  },
};
</script>

<style scoped>
.text-white-hover:hover {
  color: white !important;
}
</style>
